import { Grid } from "@material-ui/core";
import { ArrowDownward } from "@material-ui/icons";
import { EXCLUDE_QUIT_STAFF } from "app/appConfig";
import CommonButton from "app/common/Component/Button/CommonButton";
import GlobitsNumberInput from "app/common/form/GlobitsNumberInput";
import GlobitsPagingAutocomplete from "app/common/form/GlobitsPagingAutocomplete";
import GlobitsVNDCurrencyInput from "app/common/form/GlobitsVNDCurrencyInput";
import IconDelete from "app/common/Icon/IconDelete";
import { LEAD_SOURCE_LEVEL, POPUP_TYPE_CARD, POPUP_TYPE_PRODUCT, POPUP_TYPE_REGISTER_TREATMENT, POPUP_TYPE_SERVICE } from "app/common/LocalConst";
import { canBypassVisitBasedStaffSearch, getPositionCodes, getSystemConfig } from "app/common/LocalFunction";
import { renderOptionsStaff } from "app/PatientManagement/ReportSalesAllocation/ReportSalesAllocationSearch";
import { pagingCustomerSource } from "app/services/CustomerSourceService";
import { pagingPosition } from "app/services/PositionService";
import { pagingStaff } from "app/services/StaffService";
import { FieldArray, getIn, useFormikContext } from "formik";
import { observer } from "mobx-react";
import { forwardRef, memo, useEffect } from "react";
import { filterStaffOptions } from "utils";

function RegisterServiceStaffsRevenue({
  handleAddStaff,
  totalAmount = 0,
  isDisabled,
  popupType = 0, // popupType 1: form đăng kí liệu trình, 2: sản phẩm , 3: thẻ, 4: dịch vụ
}) {
  let POSITION_CODES = getPositionCodes();
  const { initialValues, values, setFieldValue } = useFormikContext();
  const remaining = values?.oldTreatmentCredit || values?.oldCredit || 0;
  useEffect(() => {
    let staffRevenues = values?.staffRevenues?.map((el) => ({
      ...el,
      actualAmount: (el?.percentRevenue * (totalAmount - remaining)) / 100,
    }));
    setFieldValue("staffRevenues", staffRevenues);
  }, [totalAmount, values?.oldCredit, values?.oldTreatmentCredit]);

  const startDateChanged = values.startDate !== initialValues.startDate;
  const urlParams = new URLSearchParams(window.location.search);
  const patientId = urlParams.get("patientId");

  const voucherIds = Array.isArray(values?.voucherAllocations)
    ? values.voucherAllocations
      .map(item => item?.voucher?.id)
      .filter(Boolean)
    : [];
  const invoiceItemIds = Array.isArray(values?.invoiceItemAllocations)
    ? values.invoiceItemAllocations
      .map(item => item?.invoiceItem?.id)
      .filter(Boolean)
    : []

  const rawVisitBasedStaffSearchConfig = getSystemConfig("ENABLE_VISIT_BASED_STAFF_SEARCH");
  const enableVisitBasedStaffSearch =
    !canBypassVisitBasedStaffSearch() &&
    (rawVisitBasedStaffSearchConfig === true ||
      String(rawVisitBasedStaffSearchConfig ?? "true").toLowerCase() === "true");

  // Gom toàn bộ logic vào 1 biến const để lấy list nguồn
  const sourceRevenueCondition =
    values?.visit?.id && !startDateChanged
      ? {
        // sửa
        visitId:
          popupType === POPUP_TYPE_REGISTER_TREATMENT || popupType === POPUP_TYPE_CARD || popupType === POPUP_TYPE_SERVICE
            ? values?.visit?.id
            : popupType === POPUP_TYPE_PRODUCT
              ? values?.visiId
              : null,
        patientId: patientId,
        voucherIds: voucherIds,
        invoiceItemIds: invoiceItemIds
      }
      : {
        // thêm
        startDate:
          popupType === POPUP_TYPE_REGISTER_TREATMENT || popupType === POPUP_TYPE_CARD
            ? values.startDate
            : popupType === POPUP_TYPE_PRODUCT
              ? values.orderDate
              : null,
        patientId: patientId,
        voucherIds: voucherIds,
        invoiceItemIds: invoiceItemIds
      };
  return (
    <FieldArray name="staffRevenues">
      {({ remove, push }) => (
        <>
          <Grid item xs={12} sm={2}>
            <GlobitsPagingAutocomplete
              label={"Nguồn"}
              name="sourceRevenue"
              api={pagingCustomerSource}
              searchObject={{
                level: LEAD_SOURCE_LEVEL.LEVEL_2.value,
                ...sourceRevenueCondition,
                departmentId: values?.department?.id,
              }}
              filterOptions={(options, state) => {
                return options.filter(
                  (option) =>
                    option?.name
                      ?.toLowerCase()
                      .includes(state?.inputValue?.toLowerCase()) ||
                    option?.code
                      ?.toLowerCase()
                      .includes(state?.inputValue?.toLowerCase())
                );
              }}
            />
          </Grid>
          <Grid item xs={12} sm={2}>
            <GlobitsPagingAutocomplete
              label={"Chọn chức danh"}
              name="position"
              api={pagingPosition}
              searchObject={{
                isUsing: true,
                positionCodes: POSITION_CODES,
                ...(enableVisitBasedStaffSearch ? { customerSourceId: values?.sourceRevenue?.id } : {}),
              }}
            />
          </Grid>

          <Grid item xs={10} sm={3}>
            <GlobitsPagingAutocomplete
              label={"Chọn nhân viên được phân bổ doanh thu"}
              api={pagingStaff}
              name={`staff`}
              displayLabel="staffName"
              autoUpercase
              searchObject={{
                positionId: values?.position?.id,
                isActive: true,
                excludeStatus: EXCLUDE_QUIT_STAFF,
                ...(enableVisitBasedStaffSearch ? { visitId: values?.visit?.id } : {}),
              }}
              getOptionDisabled={(option) => {
                const selectedService = getIn(values, "staffRevenues") || [];
                if (
                  selectedService?.find((it) => it?.staff?.id === option?.id)
                ) {
                  return false;
                }
                return false;
              }}
              ListboxComponent={forwardRef((props, ref) => {
                const { children, ...other } = props;
                return (
                  <ul {...other} ref={ref}>
                    <ol>
                      <li>{children}</li>
                    </ol>
                  </ul>
                );
              })}
              renderOption={(option) => renderOptionsStaff(option)}
              filterOptions={filterStaffOptions}
            />
          </Grid>
          <Grid item xs={2} className="flex align-end">
            <CommonButton
              onClick={() => {
                if (!isDisabled) {
                  if (handleAddStaff) {
                    handleAddStaff({
                      staff: values?.staff,
                      position: values?.position,
                      source: values?.sourceRevenue,
                      percentRevenue: 100,
                      actualAmount: totalAmount || 0,
                    });
                    setFieldValue("staff", null);
                    setFieldValue("position", null);
                    // setFieldValue("sourceRevenue", null);
                    return;
                  }

                  const dataTotalAmount =
                    totalAmount -
                    (values?.oldTreatmentCredit || values?.oldCredit || 0);
                  push({
                    staff: values?.staff,
                    position: values?.position
                      ? values?.position
                      : values?.staff?.position,
                    source: values?.sourceRevenue,
                    percentRevenue: 100,
                    actualAmount: dataTotalAmount || 0,
                  });
                  setFieldValue("staff", null);
                  setFieldValue("position", null);
                }
              }}
            >
              <ArrowDownward />
            </CommonButton>
          </Grid>

          <Grid item xs={12}>
            <div className="table-root mt-2">
              <div style={{ minWidth: "760px" }}>
                <table className="table-container">
                  <thead>
                    <tr className="row-table-header">
                      <th width="5%">STT</th>
                      <th width="10%">Thao tác</th>
                      <th width="17%">Nguồn</th>
                      <th width="20%">Chức danh</th>
                      <th width="18%">Nhân viên</th>
                      <th width="15%">Phân bổ doanh thu (%)</th>
                      <th width="15%">Phân bổ doanh thu (tiền)</th>
                    </tr>
                  </thead>
                  <tbody>
                    {values?.staffRevenues?.length > 0 &&
                      values?.staffRevenues?.map((item, index) => {
                        let positionName =
                          values?.staffRevenues[index]?.position?.name;
                        let staffName =
                          values?.staffRevenues[index]?.staff?.staffName;

                        if (!positionName) {
                          positionName = "Chưa lựa chọn";
                        }
                        if (!staffName) {
                          staffName = "Chưa lựa chọn";
                        }
                        const locked = item?.locked || isDisabled;

                        return (
                          <tr
                            key={index}
                            className={`${item?.id ? "old-staff" : ""}`}
                          >
                            <td align="center">{index + 1}</td>
                            <td align="center">
                              <span
                                tooltip={"Xóa"}
                                className="pointer tooltip"
                                onClick={() => {
                                  if (locked) return;
                                  remove(index);
                                }}
                              >
                                <IconDelete />
                              </span>
                            </td>
                            <td>
                              <GlobitsPagingAutocomplete
                                api={pagingCustomerSource}
                                name={`staffRevenues[${index}].source`}
                                autoUpercase
                                disabled={locked}
                                searchObject={{
                                  level: LEAD_SOURCE_LEVEL.LEVEL_2.value,
                                  ...sourceRevenueCondition,
                                  departmentId: values?.department?.id,
                                }}
                                isDisabled={isDisabled}
                              />
                            </td>
                            <td>
                              <GlobitsPagingAutocomplete
                                api={pagingPosition}
                                name={`staffRevenues[${index}].position`}
                                disabled={locked}
                                autoUpercase
                                searchObject={{
                                  isUsing: true,
                                  positionCodes: POSITION_CODES,
                                  ...(enableVisitBasedStaffSearch ? { customerSourceId: values?.staffRevenues[index]?.source?.id } : {}),
                                }}
                                onChange={function (_, value) {
                                  setFieldValue(
                                    `staffRevenues[${index}].position`,
                                    value
                                  );
                                  setFieldValue(
                                    `staffRevenues[${index}].staff`,
                                    null
                                  );
                                }}
                              />
                            </td>

                            <td>
                              <GlobitsPagingAutocomplete
                                api={pagingStaff}
                                name={`staffRevenues[${index}].staff`}
                                displayLabel={"staffName"}
                                disabled={locked}
                                autoUpercase
                                filterOptions={filterStaffOptions}
                                searchObject={{
                                  positionId:
                                    values?.staffRevenues[index]?.position?.id,
                                  isActive: true,
                                  excludeStatus: EXCLUDE_QUIT_STAFF,
                                  ...(enableVisitBasedStaffSearch ? { visitId: values?.visit?.id } : {}),
                                }}
                                onChange={function (_, value) {
                                  const position = getIn(
                                    values,
                                    `staffRevenues[${index}].position`
                                  );
                                  setFieldValue(
                                    `staffRevenues[${index}].staff`,
                                    value
                                  );
                                  if (!position) {
                                    setFieldValue(
                                      `staffRevenues[${index}].position`,
                                      value?.position
                                    );
                                  }
                                }}
                                ListboxComponent={forwardRef((props, ref) => {
                                  const { children, ...other } = props;
                                  return (
                                    <ul {...other} ref={ref}>
                                      <ol>
                                        <li>{children}</li>
                                      </ol>
                                    </ul>
                                  );
                                })}
                                renderOption={(option) =>
                                  renderOptionsStaff(option)
                                }
                              />
                            </td>
                            <td>
                              <GlobitsNumberInput
                                disabled={locked}
                                name={`staffRevenues[${index}].percentRevenue`}
                                onChange={(e) => {
                                  const percentRevenue = +e?.target?.value;
                                  setFieldValue(
                                    `staffRevenues[${index}].percentRevenue`,
                                    percentRevenue
                                  );
                                  const dataTotalAmount =
                                    totalAmount -
                                    (values?.oldTreatmentCredit ||
                                      values?.oldCredit ||
                                      0);
                                  setFieldValue(
                                    `staffRevenues[${index}].actualAmount`,
                                    (percentRevenue * dataTotalAmount) / 100
                                  );
                                }}
                              />
                            </td>
                            <td>
                              <GlobitsVNDCurrencyInput
                                disabled={locked}
                                name={`staffRevenues[${index}].actualAmount`}
                                onChange={(e) => {
                                  const actualAmount = +e?.target?.value;
                                  setFieldValue(
                                    `staffRevenues[${index}].actualAmount`,
                                    actualAmount
                                  );
                                  const dataTotalAmount =
                                    totalAmount -
                                    (values?.oldTreatmentCredit ||
                                      values?.oldCredit ||
                                      0);

                                  if (actualAmount > 0) {
                                    setFieldValue(
                                      `staffRevenues[${index}].percentRevenue`,
                                      (actualAmount / dataTotalAmount) * 100
                                    );
                                  }
                                }}
                              />
                            </td>
                          </tr>
                        );
                      })}
                  </tbody>
                </table>
              </div>
            </div>
          </Grid>
        </>
      )}
    </FieldArray>
  );
}

export default memo(observer(RegisterServiceStaffsRevenue));
